import { render, staticRenderFns } from "./StatusCheckbox.vue?vue&type=template&id=6b903e45&"
import script from "./StatusCheckbox.vue?vue&type=script&lang=js&"
export * from "./StatusCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports